import script from "./ShareButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareButton.vue?vue&type=script&setup=true&lang=js"

import "./ShareButton.vue?vue&type=style&index=0&id=113548fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-113548fd"]])

export default __exports__